/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IComponent, IComponentProps, ICoreContext } from '@msdyn365-commerce/core';
import React from 'react';

/**
 * Interface for table header resources.
 */
export interface IOrderReturnInitiatedDetailsTableHeaderResources {
    columnHeaderItemSKU: string;
    columnHeaderProductName: string;
    columnHeaderReturnQuantity: string;
    columnHeaderLineReturnStatus: string;
}


/**
 * Interface for table props.
 */
export interface IOrderReturnInitiatedDetailsTableHeaderProps extends IComponentProps {
    context: ICoreContext;
    className: string;
    resources: IOrderReturnInitiatedDetailsTableHeaderResources;
}

/**
 * Interface for table header component.
 */
export interface IOrderReturnInitiatedDetailsTableHeaderComponent extends IComponent<IOrderReturnInitiatedDetailsTableHeaderProps> {}

/**
 * Get the header cells for desktop.
 * @param props -- The table header props.
 * @returns The list of cells for header component in desktop version.
 */
const QuickOrderDesktopHeaderCellsComponent: React.FC<IOrderReturnInitiatedDetailsTableHeaderProps> = (props: IOrderReturnInitiatedDetailsTableHeaderProps) => {
    const { resources } = props;
    return (
        <>
            <th className={`${props.className}__header-sku`}>{resources.columnHeaderItemSKU}</th>
            <th className={`${props.className}__header-item-name`}>{resources.columnHeaderProductName}</th>
            <th className={`${props.className}__header-quantity`}>{resources.columnHeaderReturnQuantity}</th>
            <th className={`${props.className}__header-request-status`}>{resources.columnHeaderLineReturnStatus}</th>
        </>
    );
};

/**
 * Table header component.
 * @param props - Configuration of the component.
 * @returns React node with the header.
 */
export const OrderReturnInitiatedDetailsTableHeader: React.FC<IOrderReturnInitiatedDetailsTableHeaderProps> = (props: IOrderReturnInitiatedDetailsTableHeaderProps) => {
    const headerClassName = `${props.className}__header`;

    const headerCells = <QuickOrderDesktopHeaderCellsComponent {...props} />;

    return (
        <tr className={headerClassName}>{headerCells}</tr>
    );
};
